import React from 'react';

const HomePage = () => {
  return (
    <div className="container">
      <div className="card">
        <h2>환영합니다! 👋</h2>
        <p>
          이 앱은 PC, 태블릿, 모바일에서 모두 완벽하게 작동하는 반응형 웹 앱입니다.
        </p>
        <p>
          <strong>주요 특징:</strong>
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>📱 모바일: 하단 네비게이션 바</li>
          <li>💻 데스크톱/태블릿: 상단 네비게이션 바</li>
          <li>🎨 반응형 디자인으로 모든 화면 크기에 최적화</li>
          <li>⚡ 빠르고 부드러운 사용자 경험</li>
        </ul>
      </div>

      <div className="card">
        <h2>반응형 테스트</h2>
        <p>
          브라우저 창의 크기를 조절해보세요. 화면 크기에 따라 레이아웃이 자동으로 
          변경되는 것을 확인할 수 있습니다.
        </p>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
          gap: '16px',
          marginTop: '16px' 
        }}>
          <div style={{ 
            background: '#3498db', 
            color: 'white', 
            padding: '20px', 
            borderRadius: '8px', 
            textAlign: 'center' 
          }}>
            <h3>📱 모바일</h3>
            <p>320px~767px</p>
          </div>
          <div style={{ 
            background: '#2ecc71', 
            color: 'white', 
            padding: '20px', 
            borderRadius: '8px', 
            textAlign: 'center' 
          }}>
            <h3>📊 태블릿</h3>
            <p>768px~1023px</p>
          </div>
          <div style={{ 
            background: '#e74c3c', 
            color: 'white', 
            padding: '20px', 
            borderRadius: '8px', 
            textAlign: 'center' 
          }}>
            <h3>💻 데스크톱</h3>
            <p>1024px+</p>
          </div>
        </div>
      </div>

      <div className="card">
        <h2>앱 스타일 네비게이션</h2>
        <p>
          모바일에서는 하단에 네이티브 앱과 같은 네비게이션 바가 표시되며,
          태블릿과 데스크톱에서는 상단에 전통적인 네비게이션 바가 표시됩니다.
        </p>
        <p>
          이런 방식으로 각 플랫폼에 가장 적합한 UI/UX를 제공할 수 있습니다.
        </p>
      </div>
    </div>
  );
};

export default HomePage;